import React from 'react'

import './Todos.css';

export default function Todos(props) {
    const handleClick = (e) => {
      e.preventDefault();
      e.target.classList.toggle('completed');
    };
  
  
    return (
      <div className="container">
        <ul>
          {props.todos.map((todo) => {
            return (
              <li className="todo" key={todo.key}>
                <h2 onClick={handleClick}>{todo.text}</h2>
                <button className="edit-btn" onClick={() => props.editTodo(todo)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                  </svg>
                </button>
                <button className="delete-btn" onClick={() => props.handleDelete(todo.key)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    );
}
